import React from 'react';
import PropTypes from 'prop-types';
import { Button, Result } from 'antd';

export class CwoGptErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Result
          status="error"
          title="Something went wrong"
          subTitle="An unexpected error occurred. Please try again."
          extra={(
            <Button type="primary" onClick={this.handleRetry}>
              Try again
            </Button>
          )}
        />
      );
    }

    return children;
  }
}

CwoGptErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
